<template>
    <div class="devices-list__block" v-if="deviceData" @click="openChart">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
        </v-layout>
        <div class="d-inline-flex align-center small-text mt-3" v-if="deviceData.state">
            Освещённость:
            <span class="small-text font-weight-medium mx-1"> {{ deviceData.state.illuminance }} лк, </span>
            <v-img
                v-if="deviceData.state.illuminance < 21"
                max-height="22px"
                max-width="22px"
                :src="require('@/assets/icons/moon_icon.svg')"
                class="d-inline-flex"
            />
            <v-img
                v-else-if="deviceData.state.illuminance > 20 && deviceData.state.illuminance < 101"
                max-height="22px"
                max-width="22px"
                :src="require('@/assets/icons/cloudy_icon.svg')"
                class="d-inline-flex"
            />
            <v-img
                v-else-if="deviceData.state.illuminance > 101"
                max-height="22px"
                max-width="22px"
                :src="require('@/assets/icons/sun_icon.svg')"
                class="d-inline-flex"
            />
        </div>
        <ModalLightingCharts ref="modalCharts" :device-u-i-d="deviceData.uid"></ModalLightingCharts>
    </div>
</template>

<script>
import ModalLightingCharts from "@/components/modals/ModalLightingCharts";
export default {
    name: "IlluminationSensor",
    components: {ModalLightingCharts},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            deviceState: false,
            loading: false,
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
            }
        },
    },
    methods: {
        openChart() {
            if (!this.deviceData.is_action) {
                this.$refs.modalCharts.open();
            }
        },
    },
}
</script>
